import React, { useState } from 'react';

const faqs = [
  {
    question: 'What materials can I procure through Houzzdat?',
    answer: 'You can procure cement, steel, aggregates, and other construction materials. Contact us for a full list.'
  },
  {
    question: 'How does Houzzdat ensure transparent pricing?',
    answer: 'We provide upfront, itemized quotes with no hidden fees. All prices are market-competitive and updated regularly.'
  },
  {
    question: 'Can I get credit for my purchases?',
    answer: 'Yes, qualified real estate developers can access flexible credit options. Reach out to our team for details.'
  },
  {
    question: 'How do I track my order?',
    answer: 'Once your order is placed, you can track delivery status in real-time through your client dashboard or via SMS updates.'
  },
  {
    question: 'Is there a minimum order quantity?',
    answer: 'Minimum order quantities may apply depending on the material. Please contact us for specifics.'
  }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  return (
    <section className="max-w-2xl mx-auto py-12 px-4">
      <h2 className="text-2xl font-bold text-center text-primary mb-8">Frequently Asked Questions</h2>
      <div className="space-y-4">
        {faqs.map((faq, i) => (
          <div key={i} className="border border-gray-200 rounded-xl bg-white shadow-soft">
            <button
              className="w-full flex justify-between items-center px-4 py-3 text-left font-semibold text-primary focus:outline-none"
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
              aria-expanded={openIndex === i}
            >
              {faq.question}
              <span className={`ml-2 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}>▼</span>
            </button>
            {openIndex === i && (
              <div className="px-4 pb-4 text-primary text-sm md:text-base">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection; 